import {
	CaptionedImageBlock as CaptionedImageBlockType,
	EmbedBlock as EmbedBlockType,
	FeaturedContentBlock as FeaturedContentBlockType,
	ImageChooserBlock,
	ImageObjectType,
	QuoteBlock as QuoteBlockType,
	RichTextBlock as RichTextBlockType,
	DoubleListBlock,
} from "graphql/generated-types";
import React from "react";
import CaptionedImageBlock from "./CaptionedImageBlock";
import EmbedBlock from "./EmbedBlock";
import FeaturedContentBlock from "./FeaturedContentBlock";
import QuoteBlock from "./QuoteBlock";
import RichTextBlock from "./RichTextBlock";
import ColumnListBlock from "./ColumnListBlock";

type AliasedFeaturedContentBlock = FeaturedContentBlockType & {
	featuredImage: ImageObjectType;
};

export type BlockTypes =
	| RichTextBlockType
	| AliasedFeaturedContentBlock
	| CaptionedImageBlockType
	| QuoteBlockType
	| ImageChooserBlock
	| EmbedBlockType
	| DoubleListBlock;

type Props = {
	block: BlockTypes;
};

const BlockRouter = (props: Props) => {
	switch (props.block?.__typename) {
		case "RichTextBlock":
			return <RichTextBlock block={props.block} />;
		case "FeaturedContentBlock":
			return <FeaturedContentBlock {...props.block} container={true} />;
		case "CaptionedImageBlock":
			return <CaptionedImageBlock block={props.block} />;
		case "QuoteBlock":
			return <QuoteBlock block={props.block} />;
		case "EmbedBlock":
			return <EmbedBlock block={props.block} />;
		case "DoubleListBlock":
			return <ColumnListBlock block={props.block} />;
		default:
			throw Error(`Unknown Block Type - ${props.block?.__typename}`);
	}
};

export default BlockRouter;
